import { NominationsController } from 'api/controllers/NominationController';
import { NominationData } from 'api/controllers/typings';
import { GET_CURRENT_VOTING_STATISTICS } from '../queryKeys';
import { useTemplateMutation } from '../templates';

export const useNominate = useTemplateMutation<NominationData>({
  mutationFn: nomination => NominationsController.addNomination(nomination),
  refetchQueries: [GET_CURRENT_VOTING_STATISTICS],
});
